import { List, Grid, ListItem, ListItemText, Card, Typography, CardContent, LinearProgress } from "@mui/material";
import { PropTypes } from "prop-types";
import React, { useEffect, useState } from "react";
import { TopToolbar, Button, useNotify } from "react-admin";
import { telemetryService } from "../../../../services/TelemetryService";

import { V3BatchForm } from "./V3BatchForm";

const V3BatchEdit = ({ onCancel, onSuccess, selectedIds }) => {

    const [saving, setSaving] = useState(false);

    const saveConfig = async (
        configIds,
        fullPayload
    ) => {
        setSaving(true);

        const requests = configIds.map(async (id) => {
            let response;
            try {
                response = await telemetryService.saveEdgeConfig(id, fullPayload);
            } catch (err) {
                console.error({ err, object: JSON.stringify(response?.data, null, 2) });
            }
        });

        try {
            await Promise.all(requests);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <TopToolbar>
                <Button onClick={onCancel} label="Back" />
            </TopToolbar>

            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Selected V3 Devices</Typography>
                        </CardContent>

                        <List dense={true}>
                            {selectedIds.map((id) => (
                                <ListItem key={id}>
                                    <ListItemText primary={id} />
                                </ListItem>
                            ))}
                        </List>
                    </Card>
                </Grid>

                <Grid item xs={6}>
                    <V3BatchForm
                        onSave={async (details) => {
                            await saveConfig(selectedIds, details);

                            location.reload();
                            onSuccess();
                        }}
                        onCancel={onCancel}
                        saving={saving}
                    />
                </Grid>
            </Grid>
        </>
    );
};

V3BatchEdit.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    selectedIds: PropTypes.array.isRequired,
};

export { V3BatchEdit };
